import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../../../loader/Loader";
import AxiosController from "../../../../authentication/AxiosController";
import StatisticsSearchComponent from "../search components/StatisticsSearchComponent";
import { Button, Table } from "react-bootstrap";

const MarketersOverview = () => {
  const { slug, lang } = useParams();
  const { t } = useTranslation("global");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [marketerId, setProductId] = useState("");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  const getMarketersOverview = () => {
    setLoading(true);
    AxiosController.get(`api/${slug}/${lang}/reports/marketers-overview`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        start_date: startDate,
        end_date: endDate,
        marketer_id: marketerId,
      },
    })
      .then((res) => {
        setLoading(false);
        setAllData(res?.data?.orders_overview || []);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    setProductId(urlParams.get("marketer_id") || "");
    setStartDate(urlParams.get("start_date") || "");
    setEndDate(urlParams.get("end_date") || "");
  }, [urlParams]);

  useEffect(() => {
    getMarketersOverview();
  }, [startDate, endDate, marketerId]);

  return (
    <div className="flex-grow-1 stats-component py-3">
      <Button
        className="fs-5 w-25 mb-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => setSearch(!search)}
      >
        {t("panel.search")}
      </Button>
      {search && <StatisticsSearchComponent type={"marketer_overview"} />}

      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <Loader active={loading} />

        <div className="row" style={{ height: "1200px" }}>
          <div
            className="col-12"
            style={{ position: "relative", overflowX: "auto", height: "100%" }}
          >
            <Table>
              <thead>
                <tr className="text-center">
                  <th>{t("panel.affiliate")}</th>
                  <th>{t("panel.total_orders")}</th>
                  <th>{t("panel.shipped_orders")}</th>
                  <th>{t("panel.deliveredOrders")}</th>
                </tr>
              </thead>
              <tbody>
                {allData.length > 0 &&
                  allData.map((item) => (
                    <tr className="text-center" key={item?.marketer_id}>
                      <td>
                        {" "}
                        {item.marketer_id} #<br />
                        {item.marketer_first_name} {item.marketer_last_name}
                      </td>

                      <td>
                        {Number(item.total_orders_count).toLocaleString()}
                      </td>
                      <td>
                        {Number(item.shipped_orders_count).toLocaleString()}
                        <br />
                        {(
                          (Number(item.shipped_orders_count) /
                            Number(item.total_orders_count)) *
                          100
                        ).toFixed(2)}
                        %
                      </td>
                      <td>
                        {Number(item.delivered_orders_count).toLocaleString()}
                        <br />
                        {(
                          (Number(item.delivered_orders_count) /
                            Number(item.total_orders_count)) *
                          100
                        ).toFixed(2)}
                        %
                        <br />
                        {"🟢 من الطلبات المشحونه: " +
                          (
                            (Number(item.delivered_orders_count) /
                              Number(item.shipped_orders_count)) *
                            100
                          ).toFixed(2)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketersOverview;
